module.exports = __webpack_public_path__ + "static/media/02.bc0bb394.jpg";